import React from 'react';

const IconDollarSign = () => (
  <svg
    width='15'
    height='33'
    viewBox='9 0 15 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <text
      x='16.5'
      y='25'
      textAnchor='middle'
      fontFamily='-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif'
      fontSize='26'
      fontWeight='700'
      fill='white'
    >
      $
    </text>
  </svg>
);

export default IconDollarSign;
